// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "assets/" + ({"96":"vendors","117":"vendor-msal"}[chunkId] || chunkId) + "." + {"46":"74e59807f320222096b8","92":"59535e9b13896864337e","93":"70d677052c33e68cf9b0","96":"9a9b2d9b6724d45ff8ee","106":"4b0261e4bdfb054529ea","117":"d0d157b7584131b81809","397":"07874684124e223f6cd4","992":"ec3e92900d65aef506d4"}[chunkId] + ".js";
};